import { atom } from "recoil";
import { recoilPersist } from 'recoil-persist'



const { persistAtom } = recoilPersist()

const teacherState = atom({
  key: "teacher_v1",
  default: {
    fName: '',
    userId: '',
    token: null,
    lName: '',
    email: '',
  },
  effects_UNSTABLE: [persistAtom]
});


const setTeacherCookie = (obj) => {
  let ___cookies = getCookie('recoil-persist')
  let _cookies = JSON.parse(___cookies)
  var exdate=new Date();
  exdate.setDate(exdate.getDate() + 7);
  if (_cookies) {
    _cookies['teacher_v1'] = obj
    document.cookie = `recoil-persist=${JSON.stringify(_cookies)};path=/;expires=${exdate.toUTCString()}`
  }
  else {
    document.cookie = `recoil-persist=${JSON.stringify({ teacher_v1: obj })};path=/;expires=${exdate.toUTCString()}`
  }
  ////console.logdocument.cookie)
}


function getCookie(name) {
  var cookieArr = document.cookie.split(";");
  for (var i = 0; i < cookieArr.length; i++) {
    var cookiePair = cookieArr[i].split("=");
    if (name === cookiePair[0].trim()) {
      return decodeURIComponent(cookiePair[1]);
    }
  }
  return null;
}


export default getCookie;


export { teacherState, setTeacherCookie, getCookie };
